import React from "react";

// import EditRounded from "@assets/image/editRounded.svg"
import { withTranslation } from "react-i18next";

import { SvgLocationInput } from "@routes/IconeSvg";
import PlacesAutocomplete, {
  getLatLng,
  geocodeByPlaceId
} from "react-places-autocomplete";

import Loading from "@assets/image/gif/loading.gif";
import Loupe from "@assets/image/icones/employer/loup.svg";

import {
  getCountry,
  getLocality,
  getPostalCode,
  getProvince,
} from "@helpers/_functions";

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: this.props.defaultValue || "",
    };
    this.ref = React.createRef();
  }

  callPropsOnChangeAndSetAddr(address) {
    this.setState({ address });
    if (typeof this.props.onChange === "function") {
      this.props.onChange(address); 
    }
  }

  callPropsOnSelect(address = null, additionalInfo = null) {
    if (typeof this.props.onSelect === "function") {
      this.props.onSelect(
        address,
        additionalInfo,
        this.props.onUpdate || false,
      );
      //this.setState({address})
    }
  }

  handleChange = (address) => {
    if (/[!$%^&*()_+|~=`{}\[\]:\/\\;<>?@]/.test(address)) return;
    this.callPropsOnChangeAndSetAddr(address);
  };

  handleSelect = async (address, placeId) => {
    try {
      this.callPropsOnChangeAndSetAddr(address);
      const [place] = await geocodeByPlaceId(placeId);
      const latLng = await getLatLng(place);
      const postalCode = getPostalCode(place);
      const province = getProvince(place);
      const city = getLocality(place);
      const { country, countryCode } = getCountry(place);
      const adressValue = place?.formatted_address || address;
      this.callPropsOnSelect(adressValue, {
        latLng,
        postalCode,
        province,
        city,
        country,
        countryCode,
      });
    } catch (error) {
      console.error("Autocomplete Error", error);
      this.callPropsOnSelect();
    }
  };

  componentDidMount() {
    if (this.props.defaultValue && !this.state.address) {
      this.setState({
        address: this.props.defaultValue,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({
        address: this.props.defaultValue,
      });
    }
  }

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        ref={this.ref}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div
            className={`${
              this.props.className
            } arh-relative arh-flex arh-w-full arh-flex-col ${
              this.props.activeOblur ? "form_group" : ""
            }`}
          >
            {this.props.labelContent && this.props.activeOblur ? (
              <label
                className={`${this.props.labelClass} arh-mb-1 arh-font-poppins arh-text-xs arh-font-medium ${this.props.isDisabled
                    ? "arh-text-greyDisabledText  "
                    : this.props.isValid
                      ? "arh-text-black"
                      : "arh-text-[#F60A20]"
                  }`}
              >
                {this.props.label} {this.props?.required ? "*" : ""}
              </label>
            ) : this.props?.labelContent && !this.props.activeOblur ? (
                <label
                  className={`${this.props.labelClass} arh-mb-1 arh-font-poppins arh-text-xs arh-font-medium ${this.props.isDisabled
                      ? "arh-text-greyDisabledText "
                      : this.props.isValid
                        ? "arh-text-black"
                        : "arh-text-[#F60A20]"
                    }`}
                >
                {this.props.label} {this.props?.required ? "*" : ""}
              </label>
            ) : (
              <span className={this.props.labelClass}>
                {this.props.label} {this.props?.required ? "*" : ""}
              </span>
            )}
            <div className="google-autocomplete arh-relative">
              <input
                {...getInputProps({
                  placeholder: this.props.t(
                    this.props.placeholder || "Adresse",
                  ),
                  className: `${
                    this.props.classInput || "focus_blue_param"
                  } test-2 ${
                    this.props.activeOblur
                      ? "arh-rounded"
                      : "arh-w-full arh-py-3 arh-pr-12 arh-pl-6 arh-border arh-border-solid arh-border-greyBorderInput arh-font-poppins arh-font-normal arh-text-darkColor arh-text-xs arh-rounded "
                  } arh-font-poppins arh-font-normal  placeholder:!arh-text-xs  !arh-text-xs ${
                    this.props.isDisabled ? "!arh-text-greyDisabledText !arh-pointer-events-none !arh-cursor-none !arh-border-greyDisabledBorder arh-bg-greyDisabled placeholder:arh-text-greyDisabledText" : this.props.isValid ? "placeholder:!arh-text-[#8B8F91]" : "field_invalid"
                  }`,
                  name: this.props.name,
                  disabled: this.props.isDisabled,
                })}
                {...this.props.additionalInputProps}
                onBlur={this.props.activeOblur ? this.props.onBlur : null}
              />

              {
                // this.props.isDisabled ?
                //   <div onClick={this.props.onclickEdit} id="iconEdit">
                //     {this.props.icon}
                //   </div>

                loading ? (
                  <img
                    src={Loading}
                    alt=""
                    className="arh-absolute arh-top-[50%] arh-right-[0.75rem] arh-h-[1.063rem] arh-w-[1.063rem] -arh-translate-y-1/2 arh-cursor-pointer"
                  />
                ) : (
                  <img
                    src={Loupe}
                    alt=""
                    className="arh-absolute arh-top-[50%] arh-right-[0.75rem] arh-h-[1.063rem] arh-w-[1.063rem] -arh-translate-y-1/2 arh-cursor-pointer"
                  />
                )
              }
            </div>
            <div className="arh-relative">
              <div className="arh-absolute arh-top-[0rem] arh-z-[2] arh-w-full arh-rounded-[6px] arh-bg-white arh-font-poppins arh-font-normal arh-shadow-[0_3px_19px_rgba(0,0,0,8%)]">
                <div className="arh-h-full arh-max-h-[20.188rem] arh-w-full arh-overflow-y-scroll mobile-500:arh-w-[150%] ">
                  {suggestions.map((suggestion) => {
                    const { active, description } = suggestion;
                    const className = active
                      ? "arh-flex arh-items-center arh-py-[14px] arh-px-[21px] arh-text-[13px] arh-texty-[#8D8D8D] "
                      : "arh-flex arh-items-center arh-py-[14px] arh-px-[21px] arh-text-[13px] arh-texty-[#8D8D8D]  ";
                    // inline style for demonstration purpose
                    const style = active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };
                    return (
                      <div
                        key={description}
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <div className=" arh-mr-[1rem] ">
                          {SvgLocationInput()}
                        </div>
                        <span
                          className="arh-font-poppins arh-font-normal "
                          dangerouslySetInnerHTML={{
                            __html: description?.replace(
                              new RegExp(
                                this.state.address?.replace(/\s+/gi, "|"),
                                "gi",
                              ),
                              (str) =>
                                `<strong class="arh-text-darkColor">${str}</strong>`,
                            ),
                          }}
                        ></span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}
export default withTranslation("components.Input.inputWithAddOptions")(
  LocationSearchInput,
);
